// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div class="toolbar">
    <target-search v-if="$store.state.showSearchPlanets"></target-search>
  </div>
</template>

<script>

  import TargetSearch from '@/components/target-search-new'

  export default {
    data: function () {
      return {
      }
    },
    computed: {
      fov: function () {
        if (!this.$store.state.stel) return '-'
        const fov = this.$store.state.stel.fov * 180 / Math.PI
        return fov.toPrecision(3) + '°'
      }
    },
    methods: {
      toggleNavigationDrawer: function () {
        this.$store.commit('toggleBool', 'showNavigationDrawer')
      }
    },
    components: { TargetSearch }
  }
</script>

<style>
  .toolbar {
    background: transparent;
    z-index: 1;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0;
    height: 48px;
    width: 100%;
  }
</style>
